var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslateTutorialViolet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6822 6.35934H13.0596V5.04206C13.0596 4.91778 13.007 4.79933 12.9148 4.71601C12.8226 4.63269 12.6993 4.59235 12.5758 4.60486C12.5058 4.61195 10.9385 4.7892 10.1582 6.35934H8.6407V1.31783C8.64067 0.591183 8.04949 0 7.32287 0H1.31783C0.591182 0 0 0.591183 0 1.31783V7.32288C0 8.04953 0.591182 8.64069 1.3178 8.64069H1.94042V9.95797C1.94042 10.0822 1.99304 10.2007 2.08523 10.284C2.16639 10.3573 2.2715 10.3974 2.37984 10.3974C2.39458 10.3974 2.40943 10.3967 2.42423 10.3952C2.49419 10.3881 4.06151 10.2108 4.84184 8.64069H6.3593V13.6822C6.3593 14.4088 6.95048 15 7.6771 15H13.6821C14.4088 15 15 14.4088 15 13.6822V7.67717C15 6.95052 14.4088 6.35934 13.6822 6.35934ZM4.55678 7.76178C4.37648 7.76178 4.21447 7.87191 4.14814 8.03955C3.82843 8.84752 3.23947 9.21922 2.81936 9.38729V8.20123C2.81936 7.95854 2.6226 7.76178 2.3799 7.76178H1.31783C1.07581 7.76178 0.878936 7.56488 0.878936 7.32288V1.31783C0.878906 1.07581 1.07581 0.878908 1.31783 0.878908H7.32287C7.56489 0.878908 7.76177 1.07581 7.76177 1.3178V7.32285C7.76177 7.56488 7.56486 7.76175 7.32287 7.76175H4.55678V7.76178ZM14.1211 13.6822C14.1211 13.9242 13.9242 14.1211 13.6822 14.1211H7.67713C7.43511 14.1211 7.23823 13.9242 7.23823 13.6822V8.64069H7.32287C8.04952 8.64069 8.64067 8.04951 8.64067 7.32288V7.23825H10.4432C10.6235 7.23825 10.7855 7.12812 10.8519 6.96048C11.1716 6.1525 11.7605 5.78081 12.1806 5.61273V6.79879C12.1806 7.04149 12.3774 7.23825 12.6201 7.23825H13.6822C13.9242 7.23825 14.1211 7.43515 14.1211 7.67714V13.6822H14.1211Z",
    fill: "url(#paint0_linear_926_2932)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0862 5.64527C6.0806 5.64524 5.53832 5.63736 4.99884 5.36015C5.30751 4.96488 5.5508 4.42854 5.62108 3.70171H6.08438C6.32708 3.70171 6.52383 3.50495 6.52383 3.26226C6.52383 3.01956 6.32708 2.8228 6.08438 2.8228H4.75981V2.55664C4.75981 2.31395 4.56305 2.11719 4.32036 2.11719C4.07766 2.11719 3.8809 2.31395 3.8809 2.55664V2.8228H2.5563C2.31361 2.8228 2.11685 3.01956 2.11685 3.26226C2.11685 3.50495 2.31361 3.70171 2.5563 3.70171H3.0196C3.08992 4.42854 3.33317 4.96488 3.64184 5.36015C3.10237 5.63736 2.56014 5.64521 2.55627 5.64527C2.31358 5.64527 2.11682 5.84203 2.11682 6.08472C2.11682 6.32742 2.31358 6.52418 2.55627 6.52418C2.58777 6.52418 3.33627 6.51958 4.0861 6.11968C4.16297 6.07866 4.24149 6.03234 4.3203 5.98081C4.39914 6.03234 4.47762 6.07869 4.5545 6.11968C5.30432 6.51958 6.05283 6.52418 6.08432 6.52418C6.32702 6.52418 6.52468 6.32742 6.52468 6.08472C6.52468 5.84203 6.32889 5.64527 6.0862 5.64527ZM4.32036 4.79812C4.09767 4.50316 3.95834 4.13709 3.90393 3.70171H4.73675C4.68238 4.13709 4.54301 4.50316 4.32036 4.79812Z",
    fill: "url(#paint1_linear_926_2932)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0727 8.71949C10.9983 8.57061 10.8461 8.47656 10.6797 8.47656C10.5132 8.47656 10.3611 8.57061 10.2866 8.71949L8.52256 12.2476C8.41402 12.4647 8.50203 12.7286 8.71909 12.8372C8.78216 12.8687 8.84922 12.8837 8.91526 12.8837C9.07645 12.8837 9.23167 12.7946 9.30866 12.6407L9.6282 12.0016H11.7311L12.0506 12.6407C12.1592 12.8577 12.4231 12.9458 12.6402 12.8372C12.8573 12.7286 12.9453 12.4647 12.8367 12.2476L11.0727 8.71949ZM10.0677 11.1226L10.6797 9.89866L11.2916 11.1226H10.0677Z",
    fill: "url(#paint2_linear_926_2932)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.713 2.51424C10.7988 2.60005 10.9113 2.64297 11.0237 2.64297C11.1362 2.64297 11.2487 2.60008 11.3344 2.51424C11.5061 2.34262 11.5061 2.06438 11.3344 1.89276L11.2083 1.76661C12.8257 1.86244 14.1123 3.20846 14.1123 4.84955C14.1123 5.09225 14.3091 5.28901 14.5518 5.28901C14.7945 5.28901 14.9913 5.09225 14.9913 4.84955C14.9913 2.72046 13.3054 0.977935 11.1985 0.886089L11.3344 0.750181C11.5061 0.578559 11.5061 0.300326 11.3344 0.128705C11.1629 -0.042887 10.8846 -0.0429163 10.713 0.128705L9.83099 1.01075C9.65937 1.18237 9.65937 1.4606 9.83099 1.63222L10.713 2.51424Z",
    fill: "url(#paint3_linear_926_2932)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27828 12.4779C4.10669 12.3063 3.82843 12.3063 3.65681 12.4779C3.48519 12.6495 3.48519 12.9277 3.65681 13.0994L3.78296 13.2255C2.16551 13.1297 0.878906 11.7837 0.878906 10.1426C0.878906 9.89988 0.682148 9.70312 0.439453 9.70312C0.196758 9.70312 0 9.89988 0 10.1426C0 12.2717 1.68583 14.0142 3.79271 14.106L3.65681 14.242C3.48519 14.4136 3.48519 14.6918 3.65681 14.8634C3.74262 14.9492 3.85509 14.9921 3.96753 14.9921C4.07997 14.9921 4.19247 14.9492 4.27825 14.8634L5.16026 13.9814C5.33188 13.8098 5.33188 13.5315 5.16026 13.3599L4.27828 12.4779Z",
    fill: "url(#paint4_linear_926_2932)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_926_2932",
    x1: 15,
    y1: 19.1518,
    x2: -0.689026,
    y2: 18.7654,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_926_2932",
    x1: 6.52468,
    y1: 7.74397,
    x2: 1.91435,
    y2: 7.63041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_926_2932",
    x1: 12.8832,
    y1: 14.1035,
    x2: 8.27363,
    y2: 13.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_926_2932",
    x1: 14.9913,
    y1: 6.75293,
    x2: 9.45932,
    y2: 6.6167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_926_2932",
    x1: 5.28898,
    y1: 16.456,
    x2: -0.24295,
    y2: 16.3198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4322C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#48068A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslateTutorialViolet);
export default __webpack_public_path__ + "static/media/translate-tutorial-violet.d69f4d2a398b4fbaf297d065d3cf9cfe.svg";
export { ForwardRef as ReactComponent };